export default __webpack_public_path__ + "static/media/send_mail.61a7cf8d.svg";